export const POLL_UPLOAD_FAILED = 'poll_upload_failed'
export const POLL_UPLOAD_CANCELLED = 'poll_upload_cancelled'
